import {
    type BenchmarkResult, type InterruptableTask, PerformanceMeasureEngine,
} from '@tencent/speed-insights';
import type { DsiBenchmarkIndex } from './dsi-benchmark-index';
import { IDsiBenchmarkIndexes, IDsiDelegateServices } from '@src/slide/application/service/dsi-report-service/interface';

export class BaseDsiReportService {
    protected dsiBenchmarkIndexes: IDsiBenchmarkIndexes;
    protected engine: PerformanceMeasureEngine;
    private runningTask?: InterruptableTask<any>;

    public setServiceDelegate(service: IDsiDelegateServices): void {
        this.dsiBenchmarkIndexes.setServiceDelegate(service);
    }

    public async measureIndex(name: DsiBenchmarkIndex): Promise<number | undefined> {
        const results = (await this.measureOrResumeBenchmarks([name]));
        return results?.[name].value;
    }

    private async measureOrResumeBenchmarks(names: DsiBenchmarkIndex[]): Promise<
        Record<string, BenchmarkResult> | undefined
    > {
        this.cancelMeasure();
        const task = this.engine.measureBenchmarks(names);
        this.runningTask = task;
        return task?.getResult();
    }

    private cancelMeasure() {
        if (this.runningTask) {
            this.runningTask.cancel();
        }
    }
}
